import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';

//
import {account} from './modules/account'
import {cartGetters } from './getters'
import {cartMutations} from './mutations'
//import {} from './actions'

Vue.use(Vuex)
const vuexLocalStorage = new VuexPersist({
    key: 'xvue', // The key to store the state on in the storage provider.
    storage: localforage,//localforage, //window.localStorage, // or window.sessionStorage or localForage
    asyncStorage: true, // <<< ADD THIS for localforage
    // Function that passes the state and returns the state with only the objects you want to store.
    //reducer: state => state,
    reducer: state => ({
        cart: state.cart,
        account: state.account,// module.account
       // keepThisModuleToo: state.keepThisModuleToo
        // getRidOfThisModule: state.getRidOfThisModule (No one likes it.)
    })
    // Function that passes a mutation and lets you decide if it should update the state in localStorage.
    // filter: mutation => (true)
  })
  

export default new Vuex.Store({
    strict: true,
    plugins: [vuexLocalStorage.plugin],
    state: {
        //user
        store_user: {},
        // store_sellpoints: {},
        // store_sellpoint: {},
        // store_categories:{},
        // store_category:{},
        // store_products: {},
        // store_product: {},
        //cart: [],
        // bought items
        cart: [],
        //loader
        store_showLoader: false,
    },
    getters:Object.assign({}, cartGetters),
    actions:{},
    mutations:Object.assign({}, cartMutations),
    modules:{
        account: account,
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js